import { render, staticRenderFns } from "./InstallPrompt.vue?vue&type=template&id=21f10ef4&scoped=true"
import script from "./InstallPrompt.vue?vue&type=script&lang=ts"
export * from "./InstallPrompt.vue?vue&type=script&lang=ts"
import style0 from "./InstallPrompt.vue?vue&type=style&index=0&id=21f10ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f10ef4",
  null
  
)

export default component.exports